import React from "react";
import "./HoppersInputComponents.scss"
import user from "../../assets/user.svg"
import email from "../../assets/mail.svg"
import phone from "../../assets/phoneIC.svg"



const HoppersInputComponents = ({ label, value, onChange, placeholder, required, error, errorText, disable, type = "text",
    icon = ""
}) => {

    const getIcon = () => {
        switch (icon) {
            case "user":
                return user
            case "email":
                return email
            case "phone":
                return phone
            default:
                return ""
        }
    }
    return (
        <div className="HoppersInputComponents-HoppersDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`HoppersInputComponents-HoppersDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="HoppersInputComponents-HoppersDefault-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
                <img alt="" src={getIcon()}
                    className="HoppersInputComponents-HoppersDefault-container-img" />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default HoppersInputComponents
